import * as actionTypes from '../constants/smses';
import { updateObject } from '../../../../shared/utils/utility';

const initialState = {
  messageControlParameters: null,
  messageControlParametersError: null,
  messageControlParametersLoading: false,

  sendMessage: null,
  sendMessageError: null,
  sendMessageLoading: false,

  contactPhones: null,
  contactPhonesLoading: false,
  contactPhonesError: null,
};

const getMessageControlParametersStart = (state, action) => {
  return updateObject(state, {
    messageControlParametersError: null,
    messageControlParametersLoading: true,
  });
};

const getMessageControlParametersSuccess = (state, action) => {
  return updateObject(state, {
    messageControlParameters: action.data,
    messageControlParametersError: null,
    messageControlParametersLoading: false,
  });
};

const getMessageControlParametersFail = (state, action) => {
  return updateObject(state, {
    messageControlParameters: null,
    messageControlParametersError: action.error,
    messageControlParametersLoading: false,
  });
};

const setMessageControlParameters = (state, action) => {
  return updateObject(state, {
    messageControlParameters: action.data,
    messageControlParametersError: null,
    messageControlParametersLoading: false,
  });
};

const sendMessageStart = (state, action) => {
  return updateObject(state, {
    sendMessageError: null,
    sendMessageLoading: true,
  });
};

const sendMessageSuccess = (state, action) => {
  return updateObject(state, {
    sendMessage: action.data,
    sendMessageError: null,
    sendMessageLoading: false,
  });
};

const sendMessageFail = (state, action) => {
  return updateObject(state, {
    sendMessageError: action.error,
    sendMessageLoading: false,
  });
};

const getContactPhonesStart = (state, action) => {
  return updateObject(state, {
    contactPhonesError: null,
    contactPhonesLoading: true,
  });
};

const getContactPhonesSuccess = (state, action) => {
  return updateObject(state, {
    contactPhones: action.data,
    contactPhonesError: null,
    contactPhonesLoading: false,
  });
};

const getContactPhonesFail = (state, action) => {
  return updateObject(state, {
    contactPhonesError: action.error,
    contactPhonesLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SMSES_GET_MESSAGE_CONTROL_PARAMETERS_START:
      return getMessageControlParametersStart(state, action);
    case actionTypes.SMSES_GET_MESSAGE_CONTROL_PARAMETERS_SUCCESS:
      return getMessageControlParametersSuccess(state, action);
    case actionTypes.SMSES_GET_MESSAGE_CONTROL_PARAMETERS_FAIL:
      return getMessageControlParametersFail(state, action);

    case actionTypes.SMSES_SET_MESSAGE_CONTROL_PARAMETERS_SUCCESS:
      return setMessageControlParameters(state, action);

    case actionTypes.SMSES_SEND_MESSAGE_START:
      return sendMessageStart(state, action);
    case actionTypes.SMSES_SEND_MESSAGE_SUCCESS:
      return sendMessageSuccess(state, action);
    case actionTypes.SMSES_SEND_MESSAGE_FAIL:
      return sendMessageFail(state, action);

    case actionTypes.GET_CONTACT_PHONES_START:
      return getContactPhonesStart(state, action);
    case actionTypes.GET_CONTACT_PHONES_SUCCESS:
      return getContactPhonesSuccess(state, action);
    case actionTypes.GET_CONTACT_PHONES_FAIL:
      return getContactPhonesFail(state, action);

    default:
      return state;
  }
};

export default reducer;
